import { gbpCurrencyFormatter } from 'Utilities/formatters';

export const currencyFormatter = gbpCurrencyFormatter({ maximumFractionDigits: 0, minimumFractionDigits: 0 });

export const formatNumberToGBPString = (number: number): string => currencyFormatter.format(number);
